export default __webpack_public_path__ + "static/media/Grupo 6584.722421dd.svg";